export default {
    LOAD_BOX_DASHBOARD(state, box_dashboard) {
        state.items = box_dashboard;
    }
}